module.exports = __webpack_public_path__ + "fonts/Manrope-600-cyrillic14.765433f.woff2";